enum DataReportType {
  GrossRevenue = "gross-revenue",
  SegmentDistance = "segment-distance",
}

export default DataReportType;
